import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import AccueilPage from './pages/AccueilPage';
import PrestationsPage from './pages/PrestationsPage';
import ContactPage from './pages/ContactPage';
import CalendrierPage from './pages/CalendrierPage';
import CGVPage from './pages/CGVPage';
import CavalryPage from './pages/CavalryPage';

// Component to wrap all pages with common layout (Header + Body + Footer)
const Layout: React.FC = () => {
  return (
    <Router>
      <div className="app-container">
        <Header />
        {/* The Routes component ensures only one route renders at a time */}
        <main role="main" className="content-wrap">
          <Routes>
            <Route path="/" element={<AccueilPage />} />
            <Route path="/prestations" element={<PrestationsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/calendrier" element={<CalendrierPage />} />
            <Route path="/cgv" element={<CGVPage />} />
            <Route path="/chevaux" element={<CavalryPage />} />
            {/* Optional: Add a 404 page */}
            <Route element={<div className="container"><h2 className="error-heading">404 - Page non trouvée</h2></div>} />
          </Routes>
        </main>
        <Footer />
      </div >
    </Router>
  );
};

export default Layout;